import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import i18nConfig from "./core/locales/i18nConfig";
import { I18nextProvider } from "react-i18next";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "./core/store/reduxStore";
import "index.css";
import { AuthProvider } from "core/contexts/auth/auth";

// Suppress ResizeObserver errors
const originalConsoleError = console.error;
console.error = function(msg, ...args) {
  if (typeof msg === 'string' && (
    msg.includes('ResizeObserver loop') || 
    msg.includes('ResizeObserver failed') ||
    msg.includes('ResizeObserver') && msg.includes('loop')
  )) {
    // Ignore ResizeObserver loop errors
    return;
  }
  originalConsoleError(msg, ...args);
};

// Handle ResizeObserver errors globally at the window level
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    if (
      event.message && (
        event.message.includes('ResizeObserver') ||
        event.message.includes('ResizeObserver loop') ||
        event.message.includes('ResizeObserver failed')
      )
    ) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }, true);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Router>
    <ReduxProvider store={store}>
      <I18nextProvider i18n={i18nConfig}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </I18nextProvider>
    </ReduxProvider>
  </Router>
);

reportWebVitals();
